module.exports = __webpack_public_path__ + "public/img/tower2.b86ffef6.gif";